import ApiService from "./service";
import * as http from "./http";
import { ApiResponse, MediaFile } from "../models";

export class UploadService extends ApiService {
  public async upload(
    file: File,
    onUploadProgress: (progressEvent: ProgressEvent) => void
  ): Promise<ApiResponse<MediaFile>> {
    const formData = new FormData();
    formData.append("file", file);
    const url = `${this.apiDomain}/api/upload`;
    const response = await http.upload<ApiResponse<MediaFile>>(
      url,
      formData,
      onUploadProgress,
      this.store
    );
    return response.data;
  }

  public async uploadPublicFile(
    file: File,
    onUploadProgress: (progressEvent: ProgressEvent) => void
  ): Promise<ApiResponse<MediaFile>> {
    const formData = new FormData();
    formData.append("file", file);
    // const url = `${this.apiDomain}/api/upload/public-media-file`;
    const url = `${this.apiDomain}/api/upload`;
    const response = await http.upload<ApiResponse<MediaFile>>(
      url,
      formData,
      onUploadProgress,
      this.store
    );
    return response.data;
  }

  public async uploadPublic(
    file: File,
    onUploadProgress: (progressEvent: ProgressEvent) => void
  ): Promise<ApiResponse<string>> {
    const formData = new FormData();
    formData.append("file", file);
    const url = `${this.apiDomain}/api/upload/public`;
    const response = await http.upload<ApiResponse<string>>(
      url,
      formData,
      onUploadProgress,
      this.store
    );
    return response.data;
  }

  public async uploadPublicMediaFile(
    file: File,
    onUploadProgress: (progressEvent: ProgressEvent) => void
  ): Promise<ApiResponse<MediaFile>> {
    const formData = new FormData();
    formData.append("file", file);
    // const url = `${this.apiDomain}/api/upload/public-media-file`;
    const url = `${this.apiDomain}/api/upload`;
    const response = await http.upload<ApiResponse<MediaFile>>(
      url,
      formData,
      onUploadProgress,
      this.store
    );
    return response.data;
  }

  public async getSignedMediaFileUrl(mediaFile: MediaFile): Promise<string> {
    const url = `${this.apiDomain}/api/upload/get-signed-url`;

    const resposne = await http.post<ApiResponse<string>>(
      url,
      mediaFile,
      this.store
    );

    return resposne?.data?.data;
  }

  public async uploadBase64File(image: string): Promise<MediaFile> {
    const url = `${this.apiDomain}/api/upload/base64`;

    const resposne = await http.post<ApiResponse<MediaFile>>(
      url,
      { image },
      this.store
    );

    return resposne?.data?.data;
  }

  public async getSignedMediaFileUrlNoCash(
    mediaFile: MediaFile
  ): Promise<string> {
    const url = `${this.apiDomain}/api/upload/get-signed-url-no-cash`;

    const resposne = await http.post<ApiResponse<string>>(
      url,
      mediaFile,
      this.store
    );

    return resposne?.data?.data;
  }
}
